import Basis from './Basis.vue';

export default Basis;
